import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import * as Type from "./type";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { putSaga } from "src/request/put";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { deleteSaga } from "src/request/delete";

//***CONTRACT ASSETSTATUS***//
export const getContractAssetStatuses = createAction(
  "GET_CONTRACT_ASSET_STATUSES",
  ({ payload, params }: SagaActionParams<Type.ContractAssetStatusDto[]>) => ({
    payload,
    url: "/api/admin/contractassetstatus" + (params ? params : ""),
  })
);
export const getContractAssetStatusDetails = createAction(
  "GET_CONTRACT_ASSET_STATUS_DETAILS",
  ({ payload, id }: SagaActionParams<Type.ContractAssetStatusDetailDto>) => ({
    payload,
    url: "/api/admin/contractassetstatus/" + id,
  })
);
export const createContractAssetStatus = createAction(
  "CREATE_CONTRACT_ASSET_STATUS",
  ({ payload, body }: SagaActionParams<Type.ContractAssetStatusDto>) => ({
    payload,
    url: "/api/admin/contractassetstatus",
    body,
  })
);
export const updateContractAssetStatus = createAction(
  "UPDATE_CONTRACT_ASSET_STATUS",
  ({ payload, id, body }: SagaActionParams<Type.ContractAssetStatusDto>) => ({
    payload,
    url: "/api/admin/contractassetstatus/" + id,
    body,
  })
);
export const deleteContractAssetStatus = createAction(
  "DELETE_CONTRACT_ASSET_STATUS",
  ({ payload, id }: SagaActionParams<Type.ContractAssetStatusDto>) => ({
    payload,
    url: "/api/admin/contractassetstatus/" + id,
  })
);
const contractAssetStatusSaga = [
  /***************CONTRACT ASSET STATUSES***************/
  takeLatest<any>(
    getContractAssetStatuses.toString(),
    (payload: SagaGenericParams<Type.ContractAssetStatusDto[]>) =>
      getSaga<Type.ContractAssetStatusDto[]>(payload)
  ),
  takeLatest<any>(
    getContractAssetStatusDetails.toString(),
    (payload: SagaGenericParams<Type.ContractAssetStatusDetailDto>) =>
      getSaga<Type.ContractAssetStatusDetailDto>(payload)
  ),
  takeLatest<any>(
    createContractAssetStatus.toString(),
    (payload: SagaGenericParams<Type.ContractAssetStatusDetailDto>) =>
      postSaga<Type.ContractAssetStatusDetailDto>(payload)
  ),
  takeLatest<any>(
    updateContractAssetStatus.toString(),
    (payload: SagaGenericParams<Type.ContractAssetStatusDetailDto>) =>
      putSaga<Type.ContractAssetStatusDetailDto>(payload)
  ),
  takeLatest<any>(
    deleteContractAssetStatus.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.ContractAssetStatusDetailDto>(payload)
  ),
];

export default contractAssetStatusSaga;
